import { useState, useEffect } from 'react';
import ReactPaginate from 'react-paginate';
import { Form } from 'react-bootstrap';
import NoDataFound from "../../../../utilsComponent/noDataFound";
import TextTruncate from '../../../../utilsComponent/textTruncate';
import { getLocation, getPolicyMembers } from '../ClaimForm/helper';
import { format } from 'date-fns';
import { DATE_FORMAT } from '../../../../consts';

const SearchResults = (props) => {
  const { searchResults, setShowPolicyDetails, setSelectedPolicyData } = props
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    if (searchResults) {
      setCurrentItems(searchResults?.slice(itemOffset, endOffset));
      setPageCount(Math.ceil(searchResults?.length / itemsPerPage));
    }
  }, [itemOffset, itemsPerPage]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % searchResults?.length;
    setItemOffset(newOffset);
  };

  const itemPerChangeHandler = (limit) => {
    setItemsPerPage(limit);
    setItemOffset(0);
  };

  const getPolicyMembersDetails = (list) => {
    const policyHolder = getPolicyMembers(list);
    return (
      <>
        {/* {policyHolder.length} <br /> */}
        {/* Customer ID: {list?.customer_ref_id || "--"} <br /> */}
        {policyHolder.map(holder => <div><TextTruncate text={holder.name} /></div>)}
      </>
    );
  };


  return (
    <div className="border rounded p-4 px-1">
      <section className="p-4 table-responsive">
        <div className="d-flex justify-content-between">
          <h5>{searchResults && 'Search Results'} {searchResults.length === 0 ? '' : `(${searchResults.length})`}</h5>
        </div>
        <div>
          {currentItems && currentItems.length ? (
            <table className="table table-strip mt-3 text-left">
              <thead>
                <tr>
                  <th scope="col">Policy ID</th>
                  <th scope="col">Proposer Info</th>
                  <th scope="col">Policy Member</th>
                  <th scope="col">Address</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {currentItems && currentItems.length && (
                  currentItems.map((list, index) => (
                    <tr key={index}>
                      <td>{list.policy_no}</td>
                      <td>
                        <strong>
                          {list?.proposer_details
                            ? `${list.proposer_details.proposer_name || ""} ${list.proposer_details.lastname || ""}`.trim()
                            : "--"}
                        </strong>
                        <br />
                        {/* Customer ID: {list?.customer_ref_id || "--"} <br /> */}
                        {/* DOB: {getPolicyMembers(list)[0]?.dob ? format(getPolicyMembers(list)[0]?.dob, DATE_FORMAT.DD_MM_YYYY): "--"} •  */}
                        Phone no: {list?.customer_mobile}
                      </td>
                      <td>
                        {getPolicyMembersDetails(list)}
                      </td>
                      <td>
                        <TextTruncate text={getLocation(list) || "--"} length={50} />
                      </td>
                      <td className='cursor-pointer clickable-cell'
                        onClick={() => {
                          setShowPolicyDetails(true);
                          setSelectedPolicyData(list)
                        }}
                      >
                        View Details
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          ) : ""}
          {searchResults.length > 0 ? (
            <div className="d-flex align-items-center justify-content-end">
              <div className="d-flex me-3">
                Select Limit :
                <Form className="ms-3">
                  <div className="mb-3">
                    <Form.Check
                      inline
                      label="10"
                      name="itemsPerPageRadio"
                      type="radio"
                      id={`itemsPerPage-10`}
                      onChange={() => itemPerChangeHandler(10)}
                      checked={itemsPerPage === 10}
                    />
                    <Form.Check
                      inline
                      label="25"
                      name="itemsPerPageRadio"
                      type="radio"
                      id={`itemsPerPage-25`}
                      onChange={() => itemPerChangeHandler(25)}
                      checked={itemsPerPage === 25}
                    />
                    <Form.Check
                      inline
                      label="50"
                      name="itemsPerPageRadio"
                      type="radio"
                      id={`itemsPerPage-50`}
                      onChange={() => itemPerChangeHandler(50)}
                      checked={itemsPerPage === 50}
                    />
                  </div>
                </Form>
              </div>
              <ReactPaginate
                nextLabel=">>"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="<<"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                activeClassName="active"
                renderOnZeroPageCount={null}
              />
            </div>
          ) : (
            <NoDataFound text="No Data Found" />
          )}
        </div>
      </section>
    </div>
  );
};

export default SearchResults;